import React from 'react';
import { Box } from '@chakra-ui/react';
import SubRouteTopNav from '../SubRouteTopNav';
import { useHistory } from 'react-router-dom';
import WifiDetailsForm from './WifiDetailsForm';

const WifiConfiguration = () => {
  const history = useHistory();
  return (
    <Box w="100%" data-testid="wifi-configuration">
      <SubRouteTopNav title="Wifi Configuration" onGoBack={history.goBack} />
      <WifiDetailsForm />
    </Box>
  );
};

export default WifiConfiguration;
